<template>
  <div class="vx-row">
    <!-- HORIZONTAL LAYOUT -->
    <div class="vx-col w-full mb-base">
      <form
        @submit.prevent="onSubmit"
        enctype="multipart/form-data"
        id="account-manage-buttons"
      >
        <vx-card title="Create User">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                class="w-full"
                v-model="name"
                name="Name"
              />
              <span class="text-danger text-sm" v-show="errors.has('Name')">{{
                errors.first("Name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Role</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-validate="'required'"
                  v-model="role"
                  label="name"
                  item-value="id"
                  :options="list_role"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  name="Role"
                />
                <span class="text-danger text-sm" v-show="errors.has('Role')">{{
                  errors.first("Role")
                }}</span>
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Email</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required|email'"
                v-model="email"
                class="w-full"
                name="Email"
              />
              <span class="text-danger text-sm" v-show="errors.has('Email')">{{
                errors.first("Email")
              }}</span>
              <span class="text-danger text-sm" v-show="email_taken"
                >The email has already been taken.</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Password</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                v-model="password"
                class="w-full"
                name="Password"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Password')"
                >{{ errors.first("Password") }}</span
              >
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" button="submit">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import axios120 from '../../../axios120'
import router from '../../../router'
export default {
  data() {
    return {
      userAuth: JSON.parse(localStorage.getItem('user')),
      new_user: null,
      name: '',
      email: '',
      email_taken: false,
      nik: '',
      phone: '',
      id_card_photo: '',
      error_id_card_photo: false,
      role: { id: 3, name: 'Admin' },
      list_role: [{ id: 3, name: 'Admin' }, { id: 4, name: 'Mitra' }],
      password: '',
      colorAlert: 'primary',
      titleAlert: 'Alert',
      activeAlert: false,
      valueInput: '',
      file: null,

    }
  },
  components: {
    'v-select': vSelect,
    Datepicker
  },
  mounted() {


  },
  watch: {
    email(newValue, oldValue) {
      this.email_taken = ''

    },


  },

  methods: {
    onFileSelected(event) {
      this.id_card_photo = event.target.files[0]
      console.log(this.id_card_photo)

    },
    onSubmit() {

      var formData = new FormData();

      formData.append('nama_panjang', this.name)
      formData.append('role_id', this.role.id)
      formData.append('email', this.email)

      formData.append('password', this.password)
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.error_id_card_photo) {
            return
          }
          this.$vs.loading()
          axios120.post('/ecommerce/web/user', formData)
            .then(res => {
              if (res.status != 200) {
                this.$vs.loading.close()
                this.acceptAlert('warning', 'Sorry', 'Please complete input data!')
              } else {
                this.new_user = res.data

                this.$vs.loading.close()
                this.acceptAlert('success', 'Success', 'Success add user')

                router.push('/user')


              }


            })
            .catch(error => {
              console.log(error.response)
              // let list_error = error.response.data.errors

              this.email_taken = error.response.data.message

              this.$vs.loading.close()
            })
        } else {
          this.acceptAlert('warning', 'Sorry', 'Please complete input data!')
        }
      })


    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },


  }
}
</script>
